window.showCartToast = function (message) {
  let toast = document.querySelector('.cart-toast');

  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'cart-toast';
    Object.assign(toast.style, {
      position: 'fixed',
      bottom: '240px',          // أعلى شوي (مريح للعين)
      left: '50%',
      transform: 'translate(-50%, 10px)',
      background: '#1f1f1f',    // فخم
      color: '#f5f5f5',
      padding: '10px 18px',
      borderRadius: '999px',
      fontSize: '14px',
      fontWeight: '500',
      zIndex: '99999',
      opacity: '0',
      transition: 'opacity .2s ease, transform .25s ease',
      pointerEvents: 'none'
    });
    document.body.appendChild(toast);
  }

  toast.textContent = message;

  // ⬆️ دخول ناعم وسريع
  toast.style.opacity = '1';
  toast.style.transform = 'translate(-50%, 0)';

  clearTimeout(window.__toastTimer);
  window.__toastTimer = setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translate(-50%, 10px)';
  }, 1400); // ⏱️ مدة مثالية
};

/* ===========================
   CART BUBBLE – HELPERS
=========================== */
function updateCartBubbleFromCart(cart) {

  const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  if (!bubble) {
    console.warn('BUBBLE NOT FOUND');
    return;
  }

  const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
  const hiddenSpan  = bubble.querySelector('.visually-hidden');


  if (cart.item_count > 0) {
    visibleSpan.textContent = cart.item_count;
    hiddenSpan.textContent = `${cart.item_count} عناصر`;
    bubble.style.display = 'flex';
    bubble.style.opacity = '1';
  } else {
    bubble.style.display = 'none';
  }
}

 /* ============================================================
   GLOBAL.JS — CLEAN SAFE VERSION
   Everything unrelated to cart stays the same
   All cart logic removed to avoid conflicts
============================================================ */

/* ===========================
   Focus Trap
=========================== */
let trapFocusHandlers = {};

function trapFocus(container, elementToFocus = null) {
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (container !== event.target && !container.contains(event.target)) {
      elementToFocus?.focus();
    }
  };

  trapFocusHandlers.focusout = (event) => {
    if (container !== event.target && !container.contains(event.target)) {
      container.focus();
    }
  };

  trapFocusHandlers.keydown = (event) => {
    if (event.code.toUpperCase() === 'TAB') {
      if (event.target === container && event.shiftKey) {
        event.preventDefault();
        elementToFocus?.focus();
      }
    }
    if (event.code.toUpperCase() === 'ESCAPE') {
      container.dispatchEvent(new CustomEvent('escape'));
    }
  };

  document.addEventListener('focusin', trapFocusHandlers.focusin);
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('keydown', trapFocusHandlers.keydown);

  elementToFocus?.focus();
}

function removeTrapFocus(focusElement = null) {
  if (!trapFocusHandlers) return;

  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (focusElement) focusElement.focus();

  trapFocusHandlers = {};
}

/* ===========================
   Debounce
=========================== */
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

/* ===========================
   Toast Message
=========================== */
function showCartToast(message) {
  let toast = document.querySelector('.cart-toast');

  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'cart-toast';

    toast.style.position = 'fixed';
    toast.style.bottom = '80px';
    toast.style.left = '50%';
    toast.style.transform = 'translateX(-50%)';
    toast.style.background = '#000';
    toast.style.color = '#fff';
    toast.style.padding = '10px 18px';
    toast.style.borderRadius = '999px';
    toast.style.fontSize = '14px';
    toast.style.zIndex = '99999';
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 0.25s ease';
    toast.style.pointerEvents = 'none';

    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.style.opacity = '1';

  clearTimeout(window.__cartToastTimer);
  window.__cartToastTimer = setTimeout(() => {
    toast.style.opacity = '0';
  }, 2000);
}

/* ===========================
   Bubble Animation
=========================== */
function animateCartIcon() {
  const bubble = document.querySelector('.cart-anim-target');
  if (!bubble) return;

  bubble.classList.remove('cart-bump');
  void bubble.offsetWidth;
  bubble.classList.add('cart-bump');

  setTimeout(() => bubble.classList.remove('cart-bump'), 400);
}

/* ===========================
   Drawer Controls
=========================== */
function openCartDrawer() {
  const drawer = document.querySelector('cart-drawer');
  const overlay = document.getElementById('CartDrawer-Overlay');
  if (!drawer) return;

  requestAnimationFrame(() => {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('active');
    document.body.classList.add('overflow-hidden');
  });
}

function closeCartDrawer() {
  const drawer = document.querySelector('cart-drawer');
  const overlay = document.getElementById('CartDrawer-Overlay');
  if (!drawer) return;

  drawer.classList.remove('is-open');
  if (overlay) overlay.classList.remove('active');
  document.body.classList.remove('overflow-hidden');
}
function initProductAddToCart() {
  const forms = document.querySelectorAll('form.custom-ajax-cart-form');
  if (!forms.length) return;

  forms.forEach(form => {
    if (form.dataset.ajaxBound === 'true') return;
    form.dataset.ajaxBound = 'true';

    let locked = false;

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (locked) return;
      locked = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
      })
      .then(() => {
        // 🔄 تحديث السلة (فقاعة + دراور)
        document.dispatchEvent(new Event('cart:updated'));

        // 🧺 فتح الدراور
        if (typeof openCartDrawer === 'function') {
          openCartDrawer();
        }

        // ✅ رسالة "تمت الإضافة" — فقط هنا
        if (typeof window.showCartToast === 'function') {
          setTimeout(() => {
            window.showCartToast('تمت الإضافة للسلة ✔️');
          }, 80);
        }
      })
      .finally(() => {
        locked = false;
      });
    });
  });
}

document.addEventListener("click", function (e) {
  const btn = e.target.closest("button[name='checkout']");
  if (!btn) return;

  e.preventDefault();

  // إعادة تشغيل اللمعة كل مرة
  btn.classList.remove("shine-active");
  void btn.offsetWidth; // force reflow
  btn.classList.add("shine-active");

  setTimeout(() => {
    window.location.href = "/checkout";
  }, 650);
});

// تنظيف الكلاس عند الرجوع من checkout
document.addEventListener("visibilitychange", () => {
  document
    .querySelectorAll("button[name='checkout']")
    .forEach(btn => btn.classList.remove("shine-active"));
});

document.addEventListener('touchstart', function () {}, {
  passive: true
});

document.addEventListener('submit', function (e) {
  const form = e.target;

  // ✅ فقط فورم الإضافة في صفحة المنتج
  if (
    !document.body.classList.contains('template-product') ||
    !form.matches('form[data-type="add-to-cart-form"]')
  ) return;

  const btn = form.querySelector('.product-form__submit');
  if (!btn) return;

  // 🛡️ منع الدبل
  if (btn.dataset.loading === 'true') return;
  btn.dataset.loading = 'true';

  const text = btn.querySelector('.btn-text');
  const loader = btn.querySelector('.loading__spinner');

  // 🎯 تفعيل اللودر
  btn.classList.add('loading');
  text && text.classList.add('hidden');
  if (loader) {
    loader.style.opacity = '1';
    loader.style.visibility = 'visible';
  }

  // ⏱️ fallback
  setTimeout(() => {
    btn.classList.remove('loading');
    text && text.classList.remove('hidden');
    loader && (loader.style.opacity = '0');
    btn.dataset.loading = 'false';
  }, 2000);
});

document.addEventListener('cart:updated', function () {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      updateCartDrawerFooter?.(cart);
      updateFloatingCart?.();
    });
});

document.addEventListener('click', function (e) {

  // 🚫 لا يعمل داخل صفحة المنتج
  if (document.body.classList.contains('template-product')) return;

  const btn = e.target.closest('.add-to-cart-btn.inside-card');
  if (!btn) return;

  const form = btn.closest('form.custom-ajax-cart-form');
  if (!form) return;

  const variantInput = form.querySelector('input[name="id"]');
  if (!variantInput) return;

  // 🛡️ منع الدبل
  if (btn.dataset.loading === 'true') return;
  btn.dataset.loading = 'true';

  const text = btn.querySelector('.btn-text');
  const loader = btn.querySelector('.btn-loader');

  // UI
  btn.classList.add('loading');
  text && text.classList.add('hidden');
  loader && (loader.style.display = 'flex');


  
const formElement = variantInput.closest('form');
let requestBody, requestHeaders;

if (formElement) {
  requestBody = new FormData(formElement);
  requestHeaders = {}; 
} else {
  requestBody = JSON.stringify({ id: variantInput.value, quantity: 1 });
  requestHeaders = { 'Content-Type': 'application/json' };
}

fetch('/cart/add.js', {
  method: 'POST',
  headers: requestHeaders,
  body: requestBody
})
  .then(async () => {

    // 🔄 تحديث الدراور من Shopify
    const sectionRes = await fetch('/?sections=cart-drawer');
    const sections = await sectionRes.json();

    const drawerHost = document.querySelector('cart-drawer');
    if (drawerHost && sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('cart-drawer');
      if (fresh) drawerHost.innerHTML = fresh.innerHTML;
    }

    // 🔔 تحديث العداد والبابل فقط
    document.dispatchEvent(new Event('cart:updated'));

    // فتح الدراور
    openCartDrawer?.();

    // ✅ رسالة الإضافة (فقط من الصفحة الرئيسية)
    setTimeout(() => {
      window.showCartToast?.('تمت الإضافة للسلة ✔️');
    }, 30);

    updateFloatingCart?.();
  })
  .finally(() => {
    btn.classList.remove('loading');
    text && text.classList.remove('hidden');
    loader && (loader.style.display = 'none');
    btn.dataset.loading = 'false';
  });
});

function updateCartDrawerFooter(cart) {
  const emptyFooter = document.querySelector('.cart-empty-footer');
  const filledFooter = document.querySelector('.cart-filled-footer');

  if (!emptyFooter || !filledFooter) return;

  if (cart.item_count === 0) {
    emptyFooter.style.display = 'block';
    filledFooter.style.display = 'none';
  } else {
    emptyFooter.style.display = 'none';
    filledFooter.style.display = 'block';
  }
}
document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      updateCartDrawerFooter?.(cart);
      updateFloatingCart?.();
    });
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.product-form__submit');
  if (!btn) return;

  const text = btn.querySelector('.btn-text');

  // شغّل حالة التحميل
  btn.classList.add('loading');
  text && text.classList.add('hidden');

  // أمان: رجّع الزر بعد فترة لو الصفحة ما تغيّرت
  setTimeout(() => {
    btn.classList.remove('loading');
    text && text.classList.remove('hidden');
  }, 2000);
});

/* ===========================
   CART BUBBLE – INIT
=========================== */

/* عند أي تحديث للسلة */

function syncCartBubble() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      updateCartBubbleFromCart(cart);
    });
}

// عند تحميل الصفحة فقط
document.addEventListener('DOMContentLoaded', syncCartBubble);

// إيفنت واحد فقط – بدون انتظار معقد
document.addEventListener('cart:updated', () => {
  syncCartBubble();

  setTimeout(() => {
    updateDrawerBubble();
  }, 100);
});

function waitForCartIcon(callback) {
  const check = () => {
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) {
      callback();
      return;
    }
    requestAnimationFrame(check);
  };
  check();
}

function getCartIcon() {
  return (
    document.querySelector('#cart-icon-bubble') ||
    document.querySelector('.header__icon--cart') ||
    document.querySelector('a[href="/cart"]')
  );
}
function updateDrawerBubble() {
  const title = document.querySelector('.drawer__title');
  if (!title) return;

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      let bubble = title.querySelector('.drawer-bubble');

      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'drawer-bubble';
        title.style.position = 'relative';
        title.appendChild(bubble);
      }

      bubble.textContent = cart.item_count;
      bubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
}
document.addEventListener('DOMContentLoaded', () => {
  updateDrawerBubble();
});

document.addEventListener('cart:updated', () => {
  updateDrawerBubble();
});

document.addEventListener('shopify:section:load', () => {
  updateDrawerBubble();
});

document.addEventListener('submit', function (e) {
  const form = e.target;

  // فقط فورم صفحة المنتج
  if (!form.matches('form[action="/cart/add"]')) return;

  // لا نكرر لو عندك AJAX سابق
  if (form.dataset.toastBound === 'true') return;
  form.dataset.toastBound = 'true';

  setTimeout(() => {
    window.showCartToast('تمت الإضافة للسلة ✔️');
  }, 800);
});
